import React from 'react';
import { Link } from 'react-router';
import { LogOut } from 'lucide-react';
import AuthLayout from '../../components/auth/AuthLayout';
import AuthCard from '../../components/auth/AuthCard';
import LogoTile from '../../components/ui/LogoTile';
import Button from '../../components/ui/Button';
import { useTheme } from '../../contexts/ThemeContext';

const SessionExpired = () => {
  const { preference } = useTheme();
  const isLight = preference === 'light';

  return (
    <AuthLayout>
      <AuthCard>
        <div className="flex flex-col items-center text-center">
          <LogoTile
            src={`${process.env.PUBLIC_URL}/${isLight ? 'Vylo - Light BG.svg' : 'Vylo - Dark BG.svg'}`}
            alt="Vylo"
            sizeClass="h-32 w-32"
            className="-mt-2 mb-1"
          />

          {/* Icon indicator */}
          <div className="mt-4 mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/10 border border-amber-400/30">
            <LogOut className="h-7 w-7 text-amber-400" />
          </div>

          <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">
            Session Expired
          </h1>
          <p className="mt-3 text-sm text-[var(--color-text-secondary)]">
            You've been logged out automatically for security reasons. Please log in again to access your account.
          </p>
        </div>

        <div className="mt-6">
          <Link to="/login">
            <Button fullWidth>Sign In</Button>
          </Link>
        </div>
      </AuthCard>
    </AuthLayout>
  );
};

export default SessionExpired;
